import { Stack, Typography, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LandAreaAndDateFields } from "web_myplann/Portfolio/Forms/LandForm/LandAreaAndDateFields";
import { LandClassificationFields } from "web_myplann/Portfolio/Forms/LandForm/LandClassificationFields";
import { LandIdentityFields } from "web_myplann/Portfolio/Forms/LandForm/LandIdentityFields";
import { LandValueField } from "web_myplann/Portfolio/Forms/LandForm/LandValueField";
import {
	type LandFormInput,
	type LandFormOutput,
	landMinimumGroup,
} from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";
import { RealEstateTypeRow } from "web_myplann/Portfolio/Forms/RealEstateForm/RealEstateTypeRow";
import { RequiredMinimumMessage } from "web_myplann/Portfolio/PortfolioShared/RequiredMinimumMessage";

type Props = {
	control: Control<LandFormInput, unknown, LandFormOutput>;
};

const PageResources = Resources.Portfolio.AddLand;

export const LandEditFormFields = ({ control }: Props) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<Typography variant="sectionLabel">
				{t(PageResources.Sections.basicInfo)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<RealEstateTypeRow mode="locked" value={ClientPropertyTypeEnum.Land} />
				<LandIdentityFields control={control} />
				<LandAreaAndDateFields control={control} />
			</Stack>
			<RequiredMinimumMessage
				control={control}
				fields={landMinimumGroup}
				message={t(
					Resources.Portfolio.AddRealEstate.Validations.requiredMinimum,
				)}
			/>

			<Typography variant="sectionLabel">
				{t(PageResources.Sections.values)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<LandValueField control={control} isLast />
			</Stack>

			<LandClassificationFields control={control} />
		</>
	);
};
